import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import DataTable from '../../../../../components/DataTable/DataTable.js';
import { GetLastBridgeSummaryTables, GetMOCNTable, GetProximityTable } from '../../../actions/BridgeCallActions.js';
import BridgeCallStatusTable from './BridgeCallStatusTable/BridgeCallStatusTable.js';
import { Grid } from '@mui/material';
import BridgeSiteTable from './BridgeSiteTable/BridgeSiteTable.js';

const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
        padding: 0,
    },
    inner: {
        minWidth: 700,
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end',
    },
    primaryButton: {
        color: theme.palette.primary.main
    },
    errorButton: {
        color: theme.palette.error.main
    },
    infoButton: {
        color: theme.palette.info.main
    },
    customTable: {
        '& .MuiTable-root': {
            borderCollapse: 'collapse',
        },
        '& .MuiTableCell-root': {
            border: '1px solid black',
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
}));

const BridgeCallStatus = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const userId = useSelector(state => state.session.user.id);
    const summaryTables = useSelector((state) => state.bridgeCallReducer.summaryTables);
    const mocnTable = useSelector((state) => state.bridgeCallReducer.mocnTable);
    const proximityTable = useSelector((state) => state.bridgeCallReducer.proximityTable);

    useEffect(() => {
        dispatch(GetLastBridgeSummaryTables(userId));
        dispatch(GetMOCNTable(userId));
        dispatch(GetProximityTable(userId));
    }, []);

    return (
        <div style={{ marginBottom: '50px' }}>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <BridgeSiteTable
                        id="mocnTable"
                        title="MOCN Sites"
                        data={mocnTable}
                    />
                </Grid>
                <Grid item xs={6}>
                    <BridgeSiteTable
                        id="proximityTable"
                        title="MOCN Proximities"
                        data={proximityTable}
                    />
                </Grid>
            </Grid>
            {summaryTables ?
                summaryTables.map((table, index) => {
                    if (table && table.length > 0) {
                        return (
                            // <DataTable
                            //     id="bridgeCallTable"
                            //     title="Test"
                            //     pagination={false}
                            //     data={table}
                            // />
                        
                        <BridgeCallStatusTable
                            key={`bridgeCallTable${index}`}
                            tableName={`bridgeCallTable${index}`}
                            data={table}
                        />
                    );
                    }
                })
                : (<></>)
            }
        </div>
    );
};

BridgeCallStatus.propTypes = {
};

export default BridgeCallStatus;
